import React from 'react'
import { DatePicker } from '@progress/kendo-react-dateinputs'
import { IntlProvider } from '@progress/kendo-react-intl';
import { accentUserLang, accentUtils, insyteDate, t } from './../../services/HelperService'

// Calendar-date picker for InsyteDate values.
//
// Unlike AccentDateUnbound this never hands out a JS Date: `onChange` receives the canonical
// "yyyy-MM-dd" string (or null) which is exactly what the server-side InsyteDate parses and
// what Breeze / product-model JSON carries. `value` / `defaultValue` accept "yyyy-MM-dd",
// a Bridge InsyteDate or (for the legacy path) a Date.
export class AccentInsyteDateUnbound extends React.Component {

    constructor(props) {
        super(props);

        const initial = accentUtils.isNull(this.props.value) ? this.props.defaultValue : this.props.value;

        this.state = { value: insyteDate.normalize(initial) };

        this.onChange = this.onChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Controlled usage: follow `value` when the parent changes it (including clearing it).
        if ('value' in this.props && prevProps.value !== this.props.value) {
            const next = insyteDate.normalize(this.props.value);
            if (next !== this.state.value) {
                this.setState({ value: next });
            }
        }
    }

    onChange(e) {

        const value = insyteDate.normalize(e.target.value);

        this.setState({ value: value });

        if (!accentUtils.isNull(this.props.onChange)) {
            this.props.onChange(value);
        }
    }

    render() {

        const isValid = !this.props.required || !accentUtils.isNull(this.state.value);

        const className = isValid ? "accentDateUnbound accentInsyteDateUnbound" : "accentDateUnbound accentInsyteDateUnbound invalid";

        return <IntlProvider locale={accentUserLang}>
            <div data-tagname={this.props.dataTagName}>
                <DatePicker
                    className={className}
                    format="d"
                    value={insyteDate.toJsDate(this.state.value)}
                    onChange={this.onChange}
                    disabled={this.props.disabled}
                    label={accentUtils.isNull(this.props.label) ? undefined : t(this.props.label)}
                    min={insyteDate.toJsDate(this.props.min) ?? undefined}
                    max={insyteDate.toJsDate(this.props.max) ?? undefined}
                    style={{ width: "100%" }}
                />
            </div>
        </IntlProvider>;
    }
}
